import React from 'react';
import './chapters.scss';
import Chapter from './Chapter';
import InlinePhotos from '../InlinePhotos/InlinePhotos';
import { lang } from '../lang';
import ChapterHead from './ChapterHead';
import Factbox from '../Factbox/Factbox';

function Chapters() {
  const data = lang.chapters;

  return (
    <section className="chapters">
      <InlinePhotos index={0} />
      <ChapterHead data={data} index={0} />
      <Chapter data={data.chapter1} />
      <InlinePhotos index={1} />
      <Chapter data={data.chapter2} />
      <Factbox index={0} />
      <InlinePhotos index={2} />

      <Chapter data={data.chapter3} />
      <InlinePhotos index={3} />
      <Chapter data={data.chapter4} />

      <InlinePhotos index={4} />
      <Chapter data={data.chapter5} />
      <Factbox index={1} />
      <InlinePhotos index={5} />
      <ChapterHead data={data} index={1} />
      <Chapter data={data.chapter6} />
    </section>
  );
}

export default Chapters;
